import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
	"inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden whitespace-nowrap rounded-md border px-2 py-0.5 text-xs font-medium transition-[color,box-shadow] [&>svg]:size-3 [&>svg]:pointer-events-none focus-visible:ring-[3px] focus-visible:ring-brand-300/70 aria-invalid:ring-red-200 aria-invalid:border-red-500",
	{
		variants: {
			variant: {
				default:
					"border-transparent bg-brand-600 text-white [a&]:hover:bg-brand-700",
				secondary:
					"border-zinc-200 bg-zinc-100 text-zinc-700 [a&]:hover:bg-zinc-200",
				destructive:
					"border-transparent bg-red-600 text-white [a&]:hover:bg-red-700",
				outline:
					"border-zinc-300 bg-white text-zinc-800 [a&]:hover:bg-zinc-100",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

function Badge({
	className,
	variant,
	asChild = false,
	...props
}: React.ComponentProps<"span"> &
	VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
	const Comp = asChild ? Slot : "span";

	return (
		<Comp
			data-slot="badge"
			className={cn(badgeVariants({ variant }), className)}
			{...props}
		/>
	);
}

export { Badge };
